/**
 * Dotted polyline options in the given color. A stretch with no location data
 * is drawn with these so the eye still follows the route across the hole while
 * the styling says the path is inferred, not recorded.
 */
export function makeGapOptions(color: string): google.maps.PolylineOptions {
  return {
    strokeOpacity: 0,
    icons: [
      {
        icon: {
          path: 'M 0,-1 0,1',
          strokeOpacity: 0.6,
          strokeColor: color,
          scale: 3,
        },
        offset: '0',
        repeat: '10px',
      },
    ],
  };
}
